import { render, staticRenderFns } from "./scoreIntroduce.vue?vue&type=template&id=3e37ebdd&"
import script from "./scoreIntroduce.vue?vue&type=script&lang=js&"
export * from "./scoreIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./scoreIntroduce.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports